import {
  ApplicationConfig,
  provideZoneChangeDetection
} from '@angular/core';

import {
  provideRouter,
  withPreloading,
  PreloadAllModules
} from '@angular/router';

import { provideAnimations } from '@angular/platform-browser/animations';

import {
  provideTranslateService
} from '@ngx-translate/core';

import {
  provideTranslateHttpLoader
} from "@ngx-translate/http-loader";

import {
  provideHttpClient,
  withInterceptors
} from '@angular/common/http';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { telegramAuthInterceptor } from './interceptors/telegram-auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({
      eventCoalescing: true,
    }),

    provideRouter(
      routes,
      withPreloading(PreloadAllModules)
    ),

    provideAnimations(),

    provideHttpClient(
      withInterceptors([
        telegramAuthInterceptor
      ])
    ),

    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: environment.translateRoute,
        suffix: '.json'
      }),

      fallbackLang: 'en',
      lang: 'en'
    })
  ]
};
